<template>
  <div class="alert alert-warning m-0">
    Üçüncü taraf ülkesi ile organizasyon ülkesi eşit değil ise
  </div>
</template>

<script>
export default {
  props: ["value"],
  components: {},
  computed: {},
  methods: {},
};
</script>
